module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner2-8a775cb0c8f44c6fff8262d68644e99e.png";